/* eslint-disable @typescript-eslint/no-mixed-enums */
// See breakpoints: https://v5.getbootstrap.com/docs/5.0/layout/breakpoints/
export enum MediaBreakpointsEnum {
    xs = 0,
    sm = 576,
    md = 768,
    lg = 992,
    xl = 1200,
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    xsMaxWidth = 0,
    smMaxWidth = 575.98,
    mdMaxWidth = 767.98,
    lgMaxWidth = 991.98,
    xlMaxWidth = 1199.98,
    xsMediaUp = '(min-width: 0px)',
    smMediaUp = '(min-width: 576px)',
    mdMediaUp = '(min-width: 768px)',
    lgMediaUp = '(min-width: 992px)',
    xlMediaUp = '(min-width: 1200px)',
    smMediaDown = '(max-width: 575.98px)',
    mdMediaDown = '(max-width: 767.98px)',
    lgMediaDown = '(max-width: 991.98)',
    xlMediaDown = '(max-width: 1199.98)',
    xsMediaOnly = '(min-width: 575.98px)',
    smMediaOnly = '(min-width: 576px) and (max-width: 767.98px)',
    mdMediaOnly = '(min-width: 768px) and (max-width: 991.98px)',
    lgMediaOnly = '(min-width: 930px) and (max-width: 1199.98px)',
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    xlMediaOnly = '(min-width: 1200px)',
    retina = 'screen and (-webkit-min-device-pixel-ratio: 2), screen and (min-resolution: 192dpi), screen and (min-resolution: 2dppx)',
}
